import { bool, string, node, func, number, oneOfType, oneOf } from "prop-types";
import MuiAlert from "@material-ui/lab/Alert";
import MuiAlertTitle from "@material-ui/lab/AlertTitle";
import { default as MuiSnackbar } from "@material-ui/core/Snackbar";
import useStyle from "./Snackbar.style";

export const Snackbar = ({
  title,
  open,
  onClose,
  autoHideDuration,
  severity="info",
  children
}) => {

  const classes = useStyle();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;

    onClose && onClose(event);
  };

  return (
    <MuiSnackbar
      open={open}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
    >
      <MuiAlert
        elevation={6}
        variant="filled"
        onClose={onClose}
        severity={severity}
        classes={!title && { icon: classes.icon }}
      >
        {title && <MuiAlertTitle>Error</MuiAlertTitle>}
        {children}
      </MuiAlert>
    </MuiSnackbar>
  );
};

Snackbar.propTypes = {
  title: string,
  open: bool,
  onClose: func,
  autoHideDuration: number,
  severity: oneOf(["success", "error", "warning", "info"]),
  children: oneOfType([string, node]),
};
